import { render, staticRenderFns } from "./Webstars.vue?vue&type=template&id=412d7500&scoped=true&"
import script from "./Webstars.vue?vue&type=script&lang=js&"
export * from "./Webstars.vue?vue&type=script&lang=js&"
import style0 from "./Webstars.vue?vue&type=style&index=0&id=412d7500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d7500",
  null
  
)

export default component.exports